
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import EditorFieldSection from "../../../common/editor/EditorFieldSection";
import EditorFormShell from "../../../common/editor/EditorFormShell";
import FieldExpertise from "./FieldExpertise";
import FieldDescription from "./FieldDescription";
import FieldImage from "./FieldImage";
import FieldPrice from "./FieldPrice";
import FieldTitle from "./FieldTitle";
import FieldVideo from "./FieldVideo";
import DoctorMultiSelect from "../../../../components/DoctorMultiSelect";


export default function Form({ isDesktop }) {
	const navigate = useNavigate();
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [price, setPrice] = useState("");
	const [image, setImage] = useState(null);
	const [video, setVideo] = useState(null);
	const [expertiseIds, setExpertiseIds] = useState([]);
	const [instructorIds, setInstructorIds] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleTitleChange = (e) => {
		setTitle(e.target.value);
	}

	const handleDescriptionChange = (e) => {
		setDescription(e.target.value);
	}

	const handlePriceChange = (e) => {
		setPrice(e.target.value);
	}

	const handleImageChange = (e) => {
		setImage(e.target.files[0]);
	}

	const handleVideoChange = (e) => {
		setVideo(e.target.files[0]);
	}

	const handleExpertiseChange = (expertiseIds) => {
		setExpertiseIds(expertiseIds);
	}

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.workshopAdd({
			token: LoginHelper.getToken(),
			title: title,
			description: description,
			price: price,
			image_file: image,
			video_file: video,
			expertise_ids: JSON.stringify(expertiseIds),
			instructor_ids: JSON.stringify(instructorIds),
		}).then((result) => {
			setIsLoading(false);
			const workshopId = result.id;
			navigate('/workshop_detail/' + workshopId + '/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<EditorFormShell
			title="ساخت کارگاه"
			subtitle="اطلاعات کارگاه، ویدیوی معرفی و تخصص‌ها را تکمیل کنید."
			errorMessage={errorMessage}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			submitLabel="ثبت کارگاه"
		>
			<EditorFieldSection title="اطلاعات اصلی">
				<FieldTitle title={title} onChange={handleTitleChange} />
				<FieldDescription description={description} onChange={handleDescriptionChange} />
				<FieldPrice price={price} onChange={handlePriceChange} />
			</EditorFieldSection>
			<EditorFieldSection title="رسانه" description="تصویر کاور و ویدیوی معرفی">
				<FieldImage image={image} onChange={handleImageChange} />
				<FieldVideo onChange={handleVideoChange} />
			</EditorFieldSection>
			<EditorFieldSection title="تخصص‌ها">
				<FieldExpertise onChange={handleExpertiseChange} isDesktop={isDesktop} />
			</EditorFieldSection>
			{LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_ADMIN && (
				<EditorFieldSection title="مدرسین">
					<DoctorMultiSelect value={instructorIds} onChange={setInstructorIds} />
				</EditorFieldSection>
			)}
		</EditorFormShell>
	);
}
